// ✅ Trekkin.app — PanelShellViewer.jsx v2.6.0 (FINAL REAL)
// 🔹 Usado somente no modo Viewer (?share=XYZ)
// 🔹 Mapa arrasta sempre (wrapper pointerEvents: none)
// 🔹 Botões funcionam SEMPRE (painel pointerEvents: auto)
// 🔹 Painel minimizado não cria camada invisível
// 🔹 Integração total com body.panel-minimized
// 🔹 Compatível com PanelShell v3.3.0 e PanelLiveShare v3.7.3

export default function PanelShellViewer({ children }) {
  // estado lido diretamente do body (setado por PanelLiveShare)
  const isMinimized = document.body.classList.contains("panel-minimized");

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,

        // ⭐ Wrapper NÃO apanha toques!
        pointerEvents: "none",

        // ⭐ Quando minimizado: remove container overlap
        display: isMinimized ? "contents" : "flex",

        justifyContent: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          position: "absolute",

          // ⭐ Colado ao fundo (Viewer não tem bottombar)
          bottom: isMinimized
            ? "env(safe-area-inset-bottom, 12px)"
            : "20px",

          left: "10px",
          right: "10px",
          margin: "0 auto",
          maxWidth: "520px",

          // ⭐ Altura dinâmica
          maxHeight: isMinimized
            ? "130px"
            : "calc(100dvh - 70px)",

          overflowY: isMinimized ? "hidden" : "auto",

          background: "rgba(255,255,255,0.88)",
          backdropFilter: "blur(16px)",
          boxShadow: "0 4px 18px rgba(0,0,0,0.18)",
          borderRadius: "18px",

          padding: isMinimized
            ? "10px"
            : "12px 12px 20px",

          transition: "bottom 0.28s ease, max-height 0.28s ease",

          // ⭐ Este SIM apanha eventos (botões OK!)
          pointerEvents: "auto",
        }}
      >
        {children}
      </div>
    </div>
  );
}